import axios from "axios";
import * as types from "./mutation_types";

export const getItems = ({ commit }) => {
  commit(types.ASSISE_TOGGLE_LOADING);
  axios
    .get("/api/assise/my")
    .then((response) => {
      commit(types.ASSISE_TOGGLE_LOADING);
      commit(types.ASSISE_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.ASSISE_TOGGLE_LOADING);
      commit(types.ASSISE_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.ASSISE_RESET);
};
